"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recent = void 0;
var _definitions = require("@ppay/definitions");
var _utils = require("../../../utils");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _ticker = require("../../ticker");
var _ui = require("../../ui");
var _Data = require("./Data");
var _Kind = require("../Kind");
var _Details = require("../Details");
var _interfaces = require("../../../interfaces");
var _AmountTableData = require("../AmountTableData");
var _Receipt = require("../Receipt");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FirstTableData = (0, _styledComponents.default)(_Data.Data)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 0 0 16px !important;\n"])));
var LastTableData = (0, _styledComponents.default)(_Data.Data)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: right;\n  padding: 0 16px 0 0 !important;\n"])));
var WithTooltip = function WithTooltip(_ref) {
  var children = _ref.children,
    ticker = _ref.ticker,
    fee = _ref.fee,
    transacted = _ref.transacted;
  var ref = _react.default.useRef(null);
  var isMd = (0, _reactResponsive.useMediaQuery)({
    minWidth: _utils.breakpoints.md
  });
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransactionsTable'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, children), isMd && /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: ref
  }, fee && /*#__PURE__*/_react.default.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/_react.default.createElement(_ui.ExtraSmall, null, t('headers.fee'), ":", ' ', /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: fee,
    ticker: ticker
  }), " ", ticker))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/_react.default.createElement(_ui.ExtraSmall, null, t('headers.valueWhenTransacted'), ":", ' ', /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: _definitions.Ticker.USD
  }), /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: transacted,
    ticker: _definitions.Ticker.USD
  }))))));
};
var MD_SCREEN_TRUNCATE_SPLIT_POSITION = 6;
var Recent = function Recent(_ref2) {
  var transactions = _ref2.transactions,
    statusDotColor = _ref2.statusDotColor,
    onRowClick = _ref2.onRowClick,
    showModalViewAll = _ref2.showModalViewAll;
  var isMd = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  var truncateSplitPosition = isMd ? MD_SCREEN_TRUNCATE_SPLIT_POSITION : undefined;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpenModal = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    transactionToShow = _useState4[0],
    setTransactionToShow = _useState4[1];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Receipt.ReceiptModal, {
    isOpen: isOpen,
    toggle: function toggle() {
      return setOpenModal(!isOpen);
    },
    transaction: transactionToShow,
    onRowClick: onRowClick,
    statusDotColor: statusDotColor,
    showViewAll: showModalViewAll
  }), /*#__PURE__*/_react.default.createElement(_ui.Table, {
    hover: true
  }, /*#__PURE__*/_react.default.createElement(_ui.TableBody, null, transactions.map(function (transaction) {
    var _transaction$paidAmou, _transaction$paidAmou2, _transaction$paidAmou3, _transaction$fee;
    var isFiat = !!_definitions.FIAT_TICKERS.includes(transaction.ticker);
    var isWithdraw = transaction.type === _interfaces.TransactionType.WITHDRAWAL;
    var isCrypotoInvoice = !!(transaction !== null && transaction !== void 0 && transaction.paidAmount) && !transaction.isFullyPaid && !isFiat;
    var typeColor = isCrypotoInvoice ? transaction.isOverPaid ? 'warning' : 'danger' : undefined;
    // TODO refactor after adding new kind
    var amount = transaction.paidAmount ? (_transaction$paidAmou = transaction.paidAmount) === null || _transaction$paidAmou === void 0 ? void 0 : _transaction$paidAmou.value : transaction.amount.value;
    var convertedAmount = transaction.paidAmount ? (_transaction$paidAmou2 = transaction.paidAmount) === null || _transaction$paidAmou2 === void 0 ? void 0 : _transaction$paidAmou2.converted : transaction.amount.converted;
    return /*#__PURE__*/_react.default.createElement(_ui.TableRow, {
      key: transaction.id,
      role: onRowClick && 'button',
      onClick: function onClick() {
        setOpenModal(true);
        setTransactionToShow(transaction);
      },
      typeColor: typeColor
    }, /*#__PURE__*/_react.default.createElement(FirstTableData, null, /*#__PURE__*/_react.default.createElement(_Kind.Kind, {
      statusDotColor: statusDotColor,
      ticker: transaction.ticker,
      id: transaction.id,
      type: transaction.type,
      dateMillis: transaction.time,
      status: transaction.status,
      internal: transaction.internal,
      betweenAccounts: transaction.betweenAccounts,
      fiat: isFiat,
      invoiceId: transaction.invoiceId,
      target: transaction.target,
      overPaid: transaction.isOverPaid,
      paidAmount: (_transaction$paidAmou3 = transaction.paidAmount) === null || _transaction$paidAmou3 === void 0 ? void 0 : _transaction$paidAmou3.value,
      fullyPaid: transaction.isFullyPaid
    })), /*#__PURE__*/_react.default.createElement(_Details.TransactionsDetailsRecent, {
      fiatWithdraw: isFiat && isWithdraw,
      transaction: transaction,
      splitPosition: truncateSplitPosition
    }), /*#__PURE__*/_react.default.createElement(LastTableData, null, /*#__PURE__*/_react.default.createElement(WithTooltip, {
      fee: (_transaction$fee = transaction.fee) === null || _transaction$fee === void 0 ? void 0 : _transaction$fee.value,
      ticker: transaction.ticker,
      transacted: transaction.transacted.value
    }, /*#__PURE__*/_react.default.createElement(_AmountTableData.AmountTableData, {
      value: amount,
      ticker: transaction.ticker,
      convertedValue: convertedAmount,
      target: transaction.target,
      type: transaction.type,
      exchangePrice: transaction.exchangePrice
    }))));
  }))));
};
exports.Recent = Recent;